
// Centralized authentication utilities
// This utility provides consistent auth header management across all services

// Helper function to get the stored JWT token
export const getAuthToken = (): string | null => {
  const token = localStorage.getItem('auth_token');
  return token;
};

// Helper function to store the JWT token with verification
export const setAuthToken = async (token: string): Promise<void> => {
  console.log('🔑 [TOKEN_STORAGE] Storing auth token');
  localStorage.setItem('auth_token', token);
  
  // Add a small delay to ensure localStorage write completes
  await new Promise(resolve => setTimeout(resolve, 50));
  
  // Verify storage immediately
  const storedToken = localStorage.getItem('auth_token');
  console.log('🔑 [TOKEN_VERIFICATION] Token stored successfully:', storedToken === token);
  
  if (storedToken !== token) {
    console.error('🔥 [TOKEN_STORAGE] Failed to store token properly');
    throw new Error('Failed to store authentication token');
  }
};

// Helper function to remove the JWT token
export const removeAuthToken = (): void => {
  console.log('🔑 [TOKEN_REMOVAL] Removing auth token');
  localStorage.removeItem('auth_token');
};

// Helper function to get auth headers - now supports guest users
export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
    console.log('🔑 [AUTH_HEADERS] Authorization header added for authenticated user');
  } else {
    // For guest users, send a special guest token indicator
    headers['X-Guest-User'] = 'true';
    console.log('🔑 [AUTH_HEADERS] Guest user header added');
  }
  
  return headers;
};
